import { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";

const states = [
  {
    state: "पश्चिम बंगाल",
    slug:"west-bengal"
  },
  {
    state: "तमिलनाडु",
    slug:"tamil-nadu"
  },
  {
    state: "असम",
    slug:"assam"
  },
  {
    state: "केरल",
    slug:"kerala"
  },
  {
    state: "पुडुचेरी",
    slug:"puducherry"
  },
];

const SearchWidget = ({ stateName = null }) => {
  const defaultState = states.find((state) => state.state == stateName) || states[0];
  const [searchData, setSearchData] = useState({
    state: defaultState,
    constituency: "",
  });

  
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [constituencyData, setConstituencyData] = useState([]);
  const [gotoUrl, setGotoUrl] = useState(null);

  useEffect(()=>{
    function selectAPI(stateName) {
        switch (stateName) {
            case "पश्चिम बंगाल":
                return "https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/west-bengal-state-master.json?v=1763056986";
            case "तमिलनाडु":
                return "https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/tamil-nadu-state-master.json?v=1763056986";
            case "असम":
                return "https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/assam-state-master.json?v=1763056986";
            case "केरल":
                return "https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/kerala-state-master.json?v=1763056986";
            case "पुडुचेरी":
                return "https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/puducherry-state-master.json?v=1763056986";
            default:
                return "https://akm-img-a-in.tosshub.com/sites/elections/2026/assembly/json/state-master/west-bengal-state-master.json?v=1763056986";
        }
    }
    const fetchContituencyList = async () => {
        try{
            const url = selectAPI(searchData.state?.state);
            const res = await fetch(url);
            if(res.ok){
                const data = await res.json();
                setConstituencyData(data?.data);
                setSearchData(prev=>({
                    ...prev,
                    constituency:""
                }))
                setGotoUrl(`/elections/assembly-chunav/${searchData?.state?.slug}`);
            }
        }catch(e){
            console.log(e);
        }
    }

    fetchContituencyList();
  }, [searchData?.state?.state]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if(name=="state"){
      setSearchData((prevState) => ({
        ...prevState,
        state: states.find((state) => state.state == value),
      }));
      return;
    }
    setSearchData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const filteredSuggestions = useMemo(() => {
    const searchText = searchData.constituency?.trim().toLowerCase();

    if (!searchText) {
      return constituencyData;
    }

    return constituencyData.filter((cons) =>
      cons.cons_name_hi.toLowerCase().includes(searchText) ||
      cons.cons_name.toLowerCase().includes(searchText)
    );
  }, [constituencyData, searchData.constituency]);
const createSlug = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[–—−]/g, "-")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
  const handleSuggestionClick = (item) => {
    setSearchData((prevState) => ({
      ...prevState,
      constituency: item?.cons_name_hi,
    }));
    setGotoUrl(`/elections/assembly-chunav/${searchData?.state?.slug}/${createSlug(item?.cons_name)}-assembly-constituency-result-${item?.cons_id}`);
    setShowSuggestions(false);
  };
 
  return (
    <div className="bg-gray-100 p-4 mx-4 rounded-lg my-4">
      <div className="flex gap-1 items-center">
        <div className="w-8 h-8">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
          >
            <title>states</title>
            <g id="vuesax/linear/global-search">
              <g id="global-search">
                <g id="Group">
                  <path
                    id="Vector"
                    d="M18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 10.0003 1.66675C5.40033 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.40033 18.3334 10.0003 18.3334"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    id="Vector_2"
                    d="M6.66667 2.5H7.5C5.875 7.36667 5.875 12.6333 7.5 17.5H6.66667"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    id="Vector_3"
                    d="M12.5 2.5C13.3083 4.93333 13.7167 7.46667 13.7167 10"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    id="Vector_4"
                    d="M2.5 13.3333V12.5C4.93333 13.3083 7.46667 13.7167 10 13.7167"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    id="Vector_5"
                    d="M2.5 7.5C7.36667 5.875 12.6333 5.875 17.5 7.5"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
                <g id="Group_2">
                  <path
                    id="Vector_6"
                    d="M15.1667 17.8334C16.6394 17.8334 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8334 15.1667 17.8334Z"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    id="Vector_7"
                    d="M18.3333 18.3333L17.5 17.5"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <h2 className="text-md font-semibold mb-2 -ml-2 mt-1">
          अपना चुनाव क्षेत्र खोजें
        </h2>
      </div>

      <div className="flex flex-col md:flex-row gap-2">
        <select
          name="state"
          value={searchData.state?.state}
          onChange={handleInputChange}
          className="w-full md:w-2/5 bg-white text-[0.9rem]   focus:ring-primary p-3 rounded-lg"
        >
          {states.map((state) => (
            <option key={state?.state} value={state?.state}>
              {state?.state}
            </option>
          ))}
        </select>

        <div className="relative w-full md:w-2/5">
          <input
            type="text"
            name="constituency"
            value={searchData.constituency}
            onChange={handleInputChange}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => {
              setTimeout(() => {
                setShowSuggestions(false);
              }, 150);
            }}
            placeholder="चुनाव क्षेत्र खोजें"
            className="w-full bg-white text-[0.9rem]  focus:ring-primary p-3 rounded-lg"
          />

          {showSuggestions && filteredSuggestions.length > 0 && (
            <div className="absolute top-full left-0 right-0 z-10 mt-1 bg-white border border-gray-200 rounded-lg shadow-md max-h-48 overflow-y-auto">
              {filteredSuggestions.map((item) => (
                <button
                  key={item?.id}
                  type="button"
                  onMouseDown={() => handleSuggestionClick(item)}
                  className="w-full text-left px-3 py-2 hover:bg-gray-100"
                >
                  {item?.cons_name_hi}
                </button>
              ))}
            </div>
          )}
          <SVG src="https://akm-img-a-in.tosshub.com/sites/visualstory-alpha/uptak/resources/images/search.svg" className="w-5 h-5 absolute right-2 top-2"/>
        </div>

        <a href={gotoUrl} className="select-none w-2/5 ml-auto md:w-1/5 bg-primary p-2 text-white rounded-lg flex items-center justify-center gap-2 hover:bg-red-500">
          Go
          <SVG
            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/right.svg"
            className="text-white w-4 h-4"
          />
        </a>
      </div>
    </div>
  );
};

export default SearchWidget;
